import React, { useState } from "react";
import { HashLink } from "react-router-hash-link";
import styled from "styled-components";
import { css } from "styled-components";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";
import {GiHamburgerMenu} from "react-icons/gi"

function NavBar() {
    const { width } = useWindowDimensions();
    const [ isMenueOpen, setIsMenuOpen ] = useState(false);

  return (
    <NavContainer width={width}>
        <LogoBox>
            <Logo alt="Logo" style={{width: "auto", height: 50}} src={require("../assets/images/logo in circle.png")} />
            <Logo alt="Gear" style={{width: "auto", marginTop: 6, marginLeft: 10}} src={require("../assets/images/logo.png")} />
        </LogoBox>
        {
        width <= 768 ?(
        <div style={{float: "left"}}>
            <button style={{backgroundColor: colors.menuCrossBackground, borderRadius: 25, width: 45, alignItems: "center", border: 0, padding: isMenueOpen ? 7 : 0, color: "white", fontSize: 28}} 
                onClick={()=>{setIsMenuOpen(!isMenueOpen)}}
            >
                {isMenueOpen ? "X"  :<GiHamburgerMenu style={{paddingTop: 10}} />}
            </button> 
            { isMenueOpen &&(
            <InnerContainer >
                <HashRouterLink onClick={()=>{setIsMenuOpen(!isMenueOpen)}} smooth to={"#"} >Home</HashRouterLink>
                <HashRouterLink onClick={()=>{setIsMenuOpen(!isMenueOpen)}} smooth to={"#about"}>About</HashRouterLink>
                <HashRouterLink onClick={()=>{setIsMenuOpen(!isMenueOpen)}} smooth to={"#eccosystem"}>Ecosystem</HashRouterLink>
                <HashRouterLink onClick={()=>{setIsMenuOpen(!isMenueOpen)}} smooth to={"#roadmap"}>Roadmap</HashRouterLink>
                <HashRouterLink onClick={()=>{setIsMenuOpen(!isMenueOpen)}} smooth to={"#tokenomics"}>Token</HashRouterLink>
                <HashRouterLink onClick={()=>{setIsMenuOpen(!isMenueOpen)}} smooth to={"#team"}>Team</HashRouterLink>
                <HashRouterLink onClick={()=>{setIsMenuOpen(!isMenueOpen)}} smooth to={"#reference"}>Reference</HashRouterLink>
                <HashRouterLink onClick={()=>{setIsMenuOpen(!isMenueOpen)}} smooth to={"#faqs"}>Faqs</HashRouterLink>
                <HashRouterLink onClick={()=>{setIsMenuOpen(!isMenueOpen)}} smooth to={"#contact"}>Contact</HashRouterLink>
                <CreateAccountBtn 
                    style={{marginTop: 20}}
                >
                    <a href="https://forms.gle/KS1wHrQ5TQWcC8JL7" rel="noreferrer" target="_blank"
                        style={{textDecoration: "none", color: colors.white}}
                    >
                    Whitelist Request
                    </a>
                </CreateAccountBtn>
            </InnerContainer>
            )
            }
        </div>
            )
        :
        <NavInnerContainer>
            <HashRouterLink smooth to={"#"} >Home</HashRouterLink>
            <HashRouterLink smooth to={"#about"}>About</HashRouterLink>
            <HashRouterLink smooth to={"#eccosystem"}>Ecosystem</HashRouterLink>
            <HashRouterLink smooth to={"#roadmap"}>Roadmap</HashRouterLink>
            <HashRouterLink smooth to={"#tokenomics"}>Token</HashRouterLink>
            <HashRouterLink smooth to={"#team"}>Team</HashRouterLink>
            <HashRouterLink smooth to={"#reference"}>Reference</HashRouterLink>
            <HashRouterLink smooth to={"#faqs"}>Faqs</HashRouterLink>
            <HashRouterLink smooth to={"#contact"}>Contact</HashRouterLink>
            <CreateAccountBtn >
                <a href="https://forms.gle/KS1wHrQ5TQWcC8JL7" rel="noreferrer" target="_blank"
                    style={{textDecoration: "none", color: colors.white}}
                >
                Whitelist Request
                </a>
            </CreateAccountBtn>
        </NavInnerContainer>
        }
    </NavContainer>
  );
}

const NavContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #414A5C;
    padding-top: 10px;
    padding-bottom: 10px;

    @media (min-width: 1200px) {
        padding-left: ${({width})=> width * 0.1}px;
        padding-right: ${({width})=> width * 0.1}px;
    }

    @media (max-width: 1199px) {
        padding-left: ${({width})=> width * 0.05}px;
        padding-right: ${({width})=> width * 0.05}px;
        
    }

`

const LogoBox = styled.div`
    display: flex;
`

const Logo = styled.img`
    width: 90px;
    height: 40px;
`

const NavInnerContainer = styled.div`
    display: flex;
    align-items: center;

    /* @media (max-width: 768px) {
        display: block;
    } */
`

const InnerContainer = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    left: 0;
    width: 250px;
    padding: 20px;
    background-color: black;
    text-align: left;
    border-radius: 10px;

    @media (max-width: 768px) {
        
    }
`

const linkStyle = css`
    color: ${colors.white};
    text-decoration: none;
    opacity: 1;
    @media (min-width: 1200px) {
        padding-right: 30px;
    }

    @media (max-width: 1199px) {
        padding-right: 15px;
    }

    @media (max-width: 768px) {
        /* padding-right: 10px; */
        /* text-align: center; */
        padding: 10px;
        border-bottom: 0.5px solid ${colors.socialGreyDark};
        padding-left: 0px;
    }
`

const HashRouterLink = styled(HashLink)`
    ${linkStyle};
`

const CreateAccountBtn = styled.button`
    border: 0px;
    background-color: ${colors.btnPrimary};
    color: ${colors.white};
    padding: 10px 20px;
    border-radius: 5px;

    @media (min-width: 800px) {
        padding: 10px 20px;
    }

    @media (max-width: 799px) {
        padding: 10px 10px;
        font-size: 12px;
    }
`

export default NavBar;
